<app-back-button></app-back-button>
<div class="contents">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Configurações Gerais</h1>
      <p class="page-header-sub">Defina os parâmetros de configuração e gestão do sistema</p>
    </div>

    <div class="page-header-actions" *ngIf="configStats">
      <div class="header-stat-pill">
        <i class="fas fa-cog text-primary"></i>
        <span>Parâmetros: <strong>{{ totalConfigGeral }}</strong></span>
      </div>
    </div>
  </div>

  <!-- Estatísticas de Configurações -->
  <div class="config-stats-container mt-3 mb-3" *ngIf="configStats">
    <div class="config-stat-card" *ngFor="let item of configStats.configuracoesPorTipoGeral">
      <div class="config-stat-icon">
        <i class="pi pi-sliders-h"></i>
      </div>
      <div class="config-stat-info">
        <span class="config-stat-label">{{ item.configuracoesGeral }}</span>
        <span class="config-stat-value">{{ item.total }} parâmetros</span>
      </div>
    </div>

    <div class="config-stat-card institucional" *ngIf="configStats.gestaoPagina">
      <div class="config-stat-icon icon-page">
        <i class="pi pi-file-edit"></i>
      </div>
      <div class="config-stat-info">
        <span class="config-stat-label">Gestão de Páginas</span>
        <span class="config-stat-value">
          {{ configStats.gestaoPagina.configurados }} configuradas &bull;
          <span class="text-amber-600">{{ configStats.gestaoPagina.pendentes }} pendentes</span>
        </span>
      </div>
    </div>
  </div>

  <div class="config_content mt-5">
    <div class="config_header">
      <div class="icon_config_header">
        <i class="pi pi-cog"></i>
      </div>
      <h4>Configurações gerais</h4>
    </div>

    <div class="config_btns my-4">
      <button type="button" class="btn_default" [class.active]="tabIndex === 1" (click)="toggleTabsConfig(1)">
        Categoria
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 2" (click)="toggleTabsConfig(2)">
        Doação
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 3" (click)="toggleTabsConfig(3)">
        Empréstimo
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 4" (click)="toggleTabsConfig(4)">
        Recompensa
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 5" (click)="toggleTabsConfig(5)">
        Gestão Institucional
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 6" (click)="toggleTabsConfig(6)">
        FAQs
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 7" (click)="toggleTabsConfig(7)">
        Testemunhos
      </button>
      <button type="button" class="btn_default" [class.active]="tabIndex === 8" (click)="toggleTabsConfig(8)">
        Mídea
      </button>
    </div>

    <div *ngIf="tabIndex === 1">
      <app-confiuracoes-categorias />
    </div>

    <div *ngIf="tabIndex === 2">
      <app-doacao-config />
    </div>

    <div *ngIf="tabIndex === 3">
      <app-emprestimo-config />
    </div>

    <div *ngIf="tabIndex === 4">
      <app-recompensa-config />
    </div>

    <div *ngIf="tabIndex === 5">
      <app-gestao-pagina></app-gestao-pagina>
    </div>

    <div *ngIf="tabIndex === 6">
      <app-perguntas-frequentes></app-perguntas-frequentes>
    </div>

    <div *ngIf="tabIndex === 7">
      <app-testemunhos-config></app-testemunhos-config>
    </div>

    <div *ngIf="tabIndex === 8">
      <div class="content-list">
        <div class="content-card" (click)="openEditDialog(banner)">
          <div class="card-header">
            <i class="pi" [ngClass]="getIconByTipo(banner.gestaoPaginaTipoDadoENUM)"></i>

            <span class="content-type">
              {{ banner.gestaoPaginaTipoDado }} - {{ banner.gestaoPagina }}
            </span>
          </div>

          <div class="card-body">
            <p class="content-value">
              {{ banner.valor }}
            </p>

            <span class="content-date">
              <i class="pi pi-calendar"></i>
              {{ banner.dataCriacaoFormatada }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog header="Editar Conteúdo" [(visible)]="displayDialog" [modal]="true" [style]="{ width: '750px' }"
  [closable]="true">
  <form [formGroup]="form" (ngSubmit)="submit()" class="p-fluid grid">
    <!-- Tipo de Página -->
    <div class="field col-12 flex flex-column gap-2">
      <label for="GestaoPaginaENUM">Conteúdo da página</label>
      <p-select [options]="paginaOptions" formControlName="GestaoPaginaENUM" optionLabel="label" optionValue="id"
        showClear="true" placeholder="Seleccione o tipo de conteúdo" appendTo="body"></p-select>
      <small *ngIf="isInvalid('GestaoPaginaENUM')" class="p-error">
        conteúdo é obrigatório
      </small>
    </div>

    <!-- Tipo de Dado -->
    <div class="field col-12 flex flex-column gap-2">
      <label for="GestaoPaginaTipoDadoENUM">Tipo de Dado</label>
      <p-select [options]="tipoDadoOptions" formControlName="GestaoPaginaTipoDadoENUM" optionLabel="label"
        optionValue="id" placeholder="Seleccione o tipo de dado" appendTo="body" showClear="true"></p-select>
      <small *ngIf="isInvalid('GestaoPaginaTipoDadoENUM')" class="p-error">
        Tipo de dado é obrigatório
      </small>
    </div>

    <div class="field col-12 my-1">
      <span>Imagem atual</span>
      <br />
      <br />
      <img [src]="imgPreview" class="border-round-lg w-full h-10rem object-cover" />
    </div>

    <div class="fileUpload col-12 flex flex-column gap-2">
      <div class="details-file mt-2">
        <div class="file-up">
          <label for="file-upload">
            <i class="pi pi-cloud-upload"></i>
            <article>
              <strong>Foto do banner</strong>
              <p *ngIf="selectedFile">
                {{ selectedFile?.name }} -
                {{ selectedFile?.size | number: "1.0-2" }} KB
              </p>
              <p *ngIf="!selectedFile">Nenhum arquivo selecionado</p>
            </article>
            <input id="file-upload" type="file" accept=".png,.jpg,.jpeg" (change)="onFileSelected($event)" />
          </label>
          <i class="pi pi-trash" style="cursor: pointer" *ngIf="selectedFile" (click)="removeFile()"></i>
        </div>
        <small class="error" *ngIf="isInvalid('capaProjeto')">
          Foto do projeto é obrigatório.
        </small>
      </div>
    </div>

    <div class="flex justify-content-between w-full mt-2">
      <button pButton type="button" label="Cancelar" severity="secondary" (click)="closeDialog()"></button>

      <button pButton type="submit" label="Salvar" severity="success" [disabled]="form.invalid"></button>
    </div>
  </form>
</p-dialog>